import { PermissionEnum } from "@modules/account/components";

export default {
  "urn:jsonschema:eu:firstcare:api:v1:dto:employee:admin:absence:EmployeeAbsenceDTO": [
    // Rule 1.
    // Remove Consent To Share field when user does not have permission to update
    {
      tests: [
        {
          path: `/account/profile/permissions/${PermissionEnum.PRIVILEGE_EMPLOYEE_ABSENCE_CONSENT_TO_SHARE_UPDATE}`,
          value: undefined,
        },
      ],
      filters: ["hasConsentToShare"],
    },
    // Rule 2.
    // Remove absence reason when the record does not provide consent to share
    {
      tests: [
        {
          path: `/shared/employeeAbsences/absenceDetails/absenceReason`,
          value: null,
        },
      ],
      filters: ["absenceReason"],
    },
  ],
};
